import { usePaywallCustomizationContext } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PaywallCustomization/PaywallCustomizationProvider";
import { getBestFontColor } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PaywallCustomization/PriceCallout/getBestFontColor";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface UpgradePriceCalloutProps {
  priceId: number;
  showSeparator?: boolean;
}

/**
 * Match checkout price callouts: plain text by default, or a squared label in
 * the configured colour with contrasting text when highlighted.
 */
export const UpgradePriceCallout = ({
  priceId,
  showSeparator = false,
}: UpgradePriceCalloutProps) => {
  const { paywallCustomization } = usePaywallCustomizationContext();
  const properties = paywallCustomization?.price_callout_properties;
  const callout = properties?.prices?.find(
    candidate => Number(candidate?.price_id) === priceId,
  );
  const color = properties?.callout_color;

  if (!callout?.callout_text) return null;

  return (
    <span className="inline-flex shrink-0 items-baseline gap-1">
      {showSeparator && (
        <span aria-hidden="true" data-testid="upgrade-price-callout-separator">
          <Typography variant="label-xs" color="secondary">
            {t("separator_dot")}
          </Typography>
        </span>
      )}
      <Typography
        className={classNames("shrink-0 whitespace-nowrap", {
          "rounded-sm px-1.5 py-0.5": callout.highlighted,
        })}
        variant="label-xs"
        data-testid="upgrade-price-callout"
        style={
          callout.highlighted
            ? {
                backgroundColor: color,
                color: getBestFontColor(color),
              }
            : { color }
        }
      >
        {callout.callout_text}
      </Typography>
    </span>
  );
};
